import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // Initial "checking" state — keep UI empty to avoid flicker.
  if (user === undefined) {
    return (
      <div data-testid="auth-checking" className="max-w-3xl mx-auto py-24 text-center text-foreground/60">
        Checking session…
      </div>
    );
  }

  if (user === null) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
